import { cn } from "../../lib/utils"

const badgeVariants = {
  default: "bg-gray-100 text-gray-800 border-gray-200",
  success: "bg-green-100 text-green-800 border-green-200",
  warning: "bg-yellow-100 text-yellow-800 border-yellow-200",
  error: "bg-red-100 text-red-800 border-red-200",
  info: "bg-primary100 text-primary800 border-blue-200",
}

export function Badge({ 
  children, 
  variant = "default", 
  className,
  ...props 
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border",
        badgeVariants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}